const MailSignature = ({
  width = '32',
  height = '32',
}: {
  width?: string;
  height?: string;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M29.3333 11.4775V22.3335C29.3333 24.6442 27.5247 26.5325 25.2459 26.66L25 26.6668H6.99999C4.68928 26.6668 2.801 24.8582 2.67352 22.5794L2.66666 22.3335V11.4775L15.536 18.2193C15.8266 18.3716 16.1734 18.3716 16.464 18.2193L29.3333 11.4775ZM6.99999 5.3335H25C27.2463 5.3335 29.0934 7.04271 29.3117 9.23156L16 16.2046L2.68825 9.23156C2.89847 7.12378 4.61908 5.46076 6.7521 5.34047L6.99999 5.3335H25H6.99999Z"
        fill="url(#paint0_linear_52_3594)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_52_3594"
          x1="2.66666"
          y1="5.3335"
          x2="31.4505"
          y2="29.4716"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#298EE6" />
          <stop offset="1" stopColor="#1A344D" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export default MailSignature;
